import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import {
  AQI_LEVELS,
  AQI_LEVELS_COLORS,
} from 'features/aqiSensors/aqiSensors.constants';

export const AqiDescriptions = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={1}>
      <Grid
        container
        size={1}
        sx={{
          background: `linear-gradient(to bottom, ${AQI_LEVELS_COLORS[AQI_LEVELS.good]}, ${AQI_LEVELS_COLORS[AQI_LEVELS.moderate]}, ${AQI_LEVELS_COLORS[AQI_LEVELS.unhealthySensitive]}, ${AQI_LEVELS_COLORS[AQI_LEVELS.unhealthy]}, ${AQI_LEVELS_COLORS[AQI_LEVELS.veryUnhealthy]}, ${AQI_LEVELS_COLORS[AQI_LEVELS.hazardous]})`,
          borderRadius: 1,
          width: '8px',
        }}
      />
      <Grid container size={11} spacing={1}>
        {['less50', 'less100', 'less150', 'less200', 'less300', 'more300'].map(
          (key) => (
            <Grid key={key}>
              <Typography sx={{ fontWeight: 'bold' }}>
                {t(`map.legends.air.legends.${key}.titleWithLabel`)}
              </Typography>
              <Typography>
                {t(`map.legends.air.legends.${key}.subtitle`)}
              </Typography>
            </Grid>
          ),
        )}
      </Grid>
    </Grid>
  );
};
